export default __webpack_public_path__ + "static/2006-8dbc8c73358039cf516a6b8a08fde77e.gif";